import { useQuery } from "@tanstack/react-query";
import { get } from "~/Services/Request";

// we should ideally look this up once and put it into a context in the root of the app
export const useGetUserData = () => {
    return useQuery({
        queryKey: ["admin/account/getuserdata"],
        queryFn: () => {
            return get<{ userProfile?: UserProfileViewModel }>("/admin/account/getuserdata");
        },
        select: data => {
            return data.userProfile;
        },
    });
};

export interface UserProfileViewModel {
    id: string;
    userName: string;
    roles: string[];
    email: string;
    firstName: string;
    lastName: string;
    position: string;
    company: string;
    phone: string;
    extension: string;
    fax: string;
    languageId: string;
    passwordChangedOn: string;
    isAdminUser: boolean;
    defaultAdminConsoleLanguageCode: string;
}
